import store from 'app/store';
import { thunkGetAgencyTransactionList } from './agencyTransactionSlice';
import AppConstants from 'general/constants/AppConstants';
import { t } from 'i18next';
import { thunkGetInvestorList } from 'features/ManageInvestor/investorSlice';
import ToastHelper from 'general/helpers/ToastHelper';
import agencyCommissionApi from 'api/agencyCommissionApi';
import agencyApi from 'api/agencyApi';

const AgencyTransactionHelper = {
    // ---- methods ----
    callApiGetAgencyTransactionList: (params) => {
        store.dispatch(thunkGetAgencyTransactionList({ params }));
    },

    callApiUpdateAgencyTransaction: async (params) => {
        try {
            const res = await agencyApi.updateAgencyTransaction(params);
            const { result } = res;
            return result === 'success';
        } catch (error) {
            return error?.response?.data?.reason || false;
        }
    },

    callApiUpdateAgencyTransactionBatch: async (params) => {
        try {
            const res = await agencyApi.updateAgencyTransactionBatch(params);
            return res;
        } catch (error) {
            return error?.response?.data?.reason || false;
        }
    },

    // lay mau trang thai dai ly
    getAgencyStatusColor: (status) => {
        switch (status) {
            case AppConstants.agencyStatus.normal:
                return 'success';
            case AppConstants.agencyStatus.signed:
                return 'info';
            case AppConstants.agencyStatus.suspended:
                return 'gray';
            case AppConstants.agencyStatus.deleted:
                return 'danger';
            case AppConstants.agencyStatus.registered:
                return 'info';
            case 'AVAILABLE':
                return 'success'
            default:
                return 'warning';
        }
    },

    // lay mau trang thai ban hang
    getSaleStatusColor: (status) => {
        switch (status) {
            case AppConstants.saleStatus.ordered:
                return 'info';
            case AppConstants.saleStatus.shipping:
                return 'warning';
            case AppConstants.saleStatus.installing:
                return 'danger';
            case AppConstants.saleStatus.installed:
                return 'danger';
            case AppConstants.saleStatus.completed:
                return 'success';
            default:
                return 'warning';
        }
    },

    // lay mau trang thai hoa don tien dien
    getLandownerElectricityBillColor: (status) => {
        switch (status) {
            case AppConstants.energyBillStatus.validated:
                return 'success';
            case AppConstants.energyBillStatus.pending:
                return 'warning';
            default:
                return 'warning';
        }
    },

    // filter trang thai giao dich
    filterPaymentStatusOptions: () => {
        return [
            { name: t('all'), value: '' },
            {
                name: t('agencyPaymentStatus_' + AppConstants.agencyTransactionStatus.paid),
                value: AppConstants.agencyTransactionStatus.paid,
            },
            {
                name: t('agencyPaymentStatus_' + AppConstants.agencyTransactionStatus.processing),
                value: AppConstants.agencyTransactionStatus.processing,
            },
            {
                name: t('agencyPaymentStatus_' + AppConstants.agencyTransactionStatus.requested),
                value: AppConstants.agencyTransactionStatus.requested,
            },
            {
                name: t('agencyPaymentStatus_' + AppConstants.agencyTransactionStatus.rejected),
                value: AppConstants.agencyTransactionStatus.rejected,
            },
        ];
    },

    getAgencyTransactionStatusColor: (status) => {
        switch (status) {
            case AppConstants.agencyTransactionStatus.paid:
                return 'success';
            case AppConstants.agencyTransactionStatus.processing:
                return 'warning';
            case AppConstants.agencyTransactionStatus.requested:
                return 'secondary';
            case AppConstants.agencyTransactionStatus.rejected:
                return 'danger';
            default:
                return 'secondary';
        }
    },

    transactionTypeOptions: () => {
        return [
            {
                name: 'Tất cả',
                value: '',
            },
            {
                name: 'Cộng tiền',
                value: 'IN',
            },
            {
                name: 'Trừ tiền',
                value: 'OUT',
            },
        ];
    },
};

export default AgencyTransactionHelper;
